import { array, intersect, partial, string, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as StepId } from '../../../../job/hitlv2/step/Id';

export const Request = intersect(
	struct({
		stepIds: iotsUtils.NonEmptyArray(StepId),
	})
)(
	partial({
		draftRevision: string,
		pageNumbers: array(iotsUtils.PositiveInteger1Based),
	})
);
